// Module
var code = "<md-content layout-align=\"center center\" layout layout-fill flex> <div layout-margin> <h1 class=\"mr3\">This organization is currently suspended.</h1> <p class=\"grey-500\">Please contact the owner of this organization regarding this issue.</p> </div> </md-content> ";
// Exports
module.exports = code;